import { render, staticRenderFns } from "./OpenPatent.vue?vue&type=template&id=63f6925e&scoped=true"
import script from "./OpenPatent.vue?vue&type=script&lang=js"
export * from "./OpenPatent.vue?vue&type=script&lang=js"
import style0 from "./OpenPatent.vue?vue&type=style&index=0&id=63f6925e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f6925e",
  null
  
)

export default component.exports